import { StyledP } from './styles'

export type PProps = React.HTMLAttributes<HTMLParagraphElement>

export const P = (props: PProps) => {
  const { children, ...rest } = props
  return <StyledP {...rest}>{children}</StyledP>
}
